import { useAtomValue } from "jotai/index";
import { togglesAtomResettable } from "@zapier/canvas-state";
import { useComposer } from "@zapier/agent-system";
import { useCopilotChat } from "@zapier/ai-toolkit/client";

/**
 * Returns the correct chat service based on aiCobuildCopilot toggle.
 */
export function useChatService() {
  const toggles = useAtomValue(togglesAtomResettable);
  const composerService = useComposer();
  const copilotChatService = useCopilotChat();

  return toggles.aiCobuildCopilot ? copilotChatService : composerService;
}
